/**
 *
 * @param {string}  word
 * @param {string}  letter
 * @returns
 */
export const getPlural = (word, letter) => (word?.length !== 1 ? letter : "");
